import type { GraphQLFormattedError } from 'graphql';

type GraphQLErrorForReporting = Pick<
  GraphQLFormattedError,
  'extensions' | 'path'
>;

const expectedForbiddenRootFields = new Set(['post', 'stream', 'streamPosts']);

export const shouldReportGraphQLError = ({
  extensions,
  path,
}: GraphQLErrorForReporting) => {
  if (extensions?.code !== 'FORBIDDEN') {
    return true;
  }

  const rootField = path?.[0];

  return (
    typeof rootField !== 'string' ||
    !expectedForbiddenRootFields.has(rootField)
  );
};
